import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import CardSlider from 'components/consumer/CardSlider';
import { NUMBER_OF_PRODUCTS_TO_SHOW } from 'commons/constants';
import ProductCardStatic from 'components/consumer/ProductCardStatic';
import ProductCardGridUI from 'components/consumer/ProductCardGridUI';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import CardCarousel from 'components/consumer/image-slider-standard/components/CardCarousel';
import useProductListingPageContext from 'data-hooks/useProductListingPageContext';
import useMobileColumnCount from 'components/consumer/ProductListingPage/state/mobileColumnCount/useMobileColumnCount';
import CustomProductListItemPlaceholder from './CustomProductListItemPlaceholder';
const CustomProductListUI = t0 => {
  const $ = _c(25);
  const {
    listStyle: t1
  } = t0;
  const listStyle = t1 === undefined ? "Slider" : t1;
  const {
    filterStateKey,
    isAllDataLoading,
    loading,
    products,
    productsToPreload
  } = useProductListingPageContext();
  const mobileColumnCount = useMobileColumnCount();
  const skeletonLoaderItems = products?.length > 0 && products?.length < NUMBER_OF_PRODUCTS_TO_SHOW ? NUMBER_OF_PRODUCTS_TO_SHOW - products.length : NUMBER_OF_PRODUCTS_TO_SHOW;
  let t2;
  if ($[0] !== products || $[1] !== productsToPreload) {
    t2 = [...products, ...(productsToPreload ?? []).map(_temp)];
    $[0] = products;
    $[1] = productsToPreload;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const allProductsToShow = t2;
  let t3;
  if ($[3] !== allProductsToShow || $[4] !== filterStateKey || $[5] !== listStyle || $[6] !== loading) {
    t3 = !loading && allProductsToShow?.map((t4, index) => {
      const {
        campaign,
        id,
        isClearance,
        isFavorited,
        isHidden,
        label,
        moreVariantsCount,
        name,
        onDisplayInShowroomSlug,
        path,
        position,
        productFamily,
        productLabel,
        productType,
        quickship,
        secondaryImage,
        secondaryImageCropData,
        slug,
        variants,
        variantsToShow,
        variantsTotal
      } = t4;
      return <ProductCardStatic campaign={campaign} disableImageLazyLoading={listStyle === "Grid" && index < 12} enableMobileCarousel={false} filterStateKey={filterStateKey} hidden={isHidden} id={id} isFavorited={isFavorited} isClearance={isClearance} key={`${slug}-${index}`} label={label} layout="minimal-with-attributes" moreVariantsCount={moreVariantsCount} name={name} onDisplayInShowroomSlug={onDisplayInShowroomSlug} path={path} position={position} productFamily={productFamily} productLabel={productLabel} productType={productType} quickship={quickship} secondaryImage={secondaryImage} secondaryImageCropData={secondaryImageCropData} slug={slug} variants={variants} variantsToShow={variantsToShow} variantsTotal={variantsTotal} />;
    });
    $[3] = allProductsToShow;
    $[4] = filterStateKey;
    $[5] = listStyle;
    $[6] = loading;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const productsList = t3;
  if (listStyle === "Carousel") {
    let t4;
    if ($[8] !== productsList) {
      t4 = <FixedWidthContainer className="CustomProductListUI"><CardCarousel imageHeight={350} imageWidth={350} navType="Button" visibleSlides={4}>{productsList}</CardCarousel></FixedWidthContainer>;
      $[8] = productsList;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  if (listStyle === "Slider") {
    let t4;
    if ($[10] !== productsList) {
      t4 = <div className="max-w-[1500px] mx-auto my-0"><CardSlider wide={false}>{productsList}</CardSlider></div>;
      $[10] = productsList;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    return t4;
  }
  if (!loading && !products?.length) {
    let t4;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <FixedWidthContainer className="max-[1023px]:!p-0"><div className="text-lg font-bold flex flex-col items-center justify-center px-0 py-8 min-h-[30vh]">Looks like these deals sold out in a flash! Check back soon for more opportunities to save big.</div></FixedWidthContainer>;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    return t4;
  }
  let t4;
  if ($[13] !== loading || $[14] !== skeletonLoaderItems) {
    t4 = loading && [...Array(skeletonLoaderItems)].map(_temp2);
    $[13] = loading;
    $[14] = skeletonLoaderItems;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== isAllDataLoading || $[17] !== loading || $[18] !== skeletonLoaderItems) {
    t5 = !loading && isAllDataLoading && [...Array(skeletonLoaderItems)].map(_temp3);
    $[16] = isAllDataLoading;
    $[17] = loading;
    $[18] = skeletonLoaderItems;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== mobileColumnCount || $[21] !== productsList || $[22] !== t4 || $[23] !== t5) {
    t6 = <FixedWidthContainer className="max-[1023px]:!p-0"><ProductCardGridUI columnsOnDesktop="auto" columnsOnMobile={mobileColumnCount} limitWidth={false}>{t4}{productsList}{t5}</ProductCardGridUI></FixedWidthContainer>;
    $[20] = mobileColumnCount;
    $[21] = productsList;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  return t6;
};
CustomProductListUI.propTypes = {
  listStyle: PropTypes.oneOf(['Slider', 'Carousel', 'Grid'])
};
export default CustomProductListUI;
function _temp(product) {
  return {
    ...product,
    isHidden: true
  };
}
function _temp2(item, index_0) {
  return <CustomProductListItemPlaceholder key={`placeholder-${index_0}`} />;
}
function _temp3(item_0, index_1) {
  return <CustomProductListItemPlaceholder key={`placeholder-${index_1}`} />;
}